/**
 * Basic version information for the editor.
 * Used to determine if the editor installed in the site is up to date with master.
 */
module.exports = {
    version: 774,
};
